import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { AgreementsService } from "../../../../shared/services/agreements.service";
import { AgreementSearchedDto } from "../../../../shared/models/agreement/agreement-searched.dto";
import { AgreementsSelectionService } from "./agreements-selection-service";

@Component({
    selector: 'search-agreements-autocomplete',
    templateUrl: './search-agreements-autocomplete.component.html',
    styleUrls: ['./search-agreements-autocomplete.component.scss']
})
export class SearchAgreementsAutoCompleteComponent implements OnInit, OnDestroy {

    minCharactesCount: number = 2;

    agreements: AgreementSearchedDto[] = [];

    agreementsSelectionSubscription: any;

    searchPauseTime = 500;
    searchDelay: NodeJS.Timer;
    searchSubsription: Subscription;
    searching: boolean = false;

    constructor(
        public agreementsService: AgreementsService,
        public agreementsSelectionService: AgreementsSelectionService
    ) { }

    ngOnInit(): void {
        this.agreementsSelectionSubscription = this.agreementsSelectionService.agreementsForced$.subscribe(
            (value) => {
                this.agreementsSelectionSubscription = this.agreementsService.searchAgreements(value)
                    .subscribe((response) => {
                        this.agreements = response;
                    });
            }
        );
    }

    ngOnDestroy() {
        if (this.agreementsSelectionSubscription) {
            this.agreementsSelectionSubscription.unsubscribe();
        }
    }

    agreementChange(value: string): void {
        if (value && value != '' && this.agreements.some(x => x.agreementId.toString() == value)) {
            window.open(`/categories/agreement/${value}`, '_blank');
        }
    }

    agreementsFilterChange(value: string): void {
        if (!value || value.trim() == '' || value.trim().length < this.minCharactesCount) {
            this.agreements = [];
        }
        else {
            this.searchAgreements(value);
        }
    }

    searchAgreements(value: string) {
        if (this.searchDelay) {
            clearTimeout(this.searchDelay);
        }

        this.searchDelay = setTimeout(() => {
            if (this.searchSubsription) {
                this.searchSubsription.unsubscribe();
            }

            this.searching = true;
            this.searchSubsription = this.agreementsService.searchAgreements(value)
                .subscribe((response) => {
                    this.agreements = response;
                    this.searching = false;
                });
        }, this.searchPauseTime);
    }

    getMatchedValueHtml(dataItem: AgreementSearchedDto): string {
        let start = dataItem.matchedFullValue.substring(0, dataItem.matchedStartIndex);
        let middle = dataItem.matchedFullValue.substring(dataItem.matchedStartIndex, dataItem.matchedEndIndex + 1);
        let end = dataItem.matchedFullValue.substring(dataItem.matchedEndIndex + 1);

        let resultString = '';

        if (start && start != '') {
            resultString += start
        }

        resultString += `<b>${middle}</b>`;

        if (end && end != '') {
            resultString += end;
        }

        return resultString;
    }
}

